import { ARBITRAGE_GET_REQUEST, ARBITRAGE_GET_SUCCESS, ARBITRAGE_GET_FAILURE } from "../actions";

export default function states(state = { loading: true, data: [] }, action) {
  switch (action.type) {
    case ARBITRAGE_GET_REQUEST:
      return { loading: true, data: [] };
    case ARBITRAGE_GET_SUCCESS:
      return { loading: false, data: action.data };
    case ARBITRAGE_GET_FAILURE:
      return { loading: false, error: action.error };
    default:
      return state;
  }
}
